import React from 'react'
import { Chip, useTheme, alpha, SxProps, Theme } from '@mui/material'

export interface StatusChipProps {
  status?: string | null
  icon?: React.ReactElement
  sx?: SxProps<Theme>
}

const StatusChip: React.FC<StatusChipProps> = ({ status, icon, sx = {} }) => {
  const theme = useTheme()

  const s = status ? status.toUpperCase() : 'UNKNOWN'

  let baseColor = theme.palette.info.main

  if (
    [
      'ACTIVE',
      'SENT',
      'PAID',
      'DELIVERED',
      'OPEN',
      'CASH',
      'ACCEPTED',
      'CONVERTED',
      'ENROLLED',
      'APPROVED',
      'ASSET',
      'REVENUE',
      'EQUITY',
      'CREATE',
      'IN_STOCK',
      'NON_TAXABLE',
      'INITIAL_STOCK',
      'PURCHASE_RECEIPT',
      'INFLOW',
      'NON_TAXABLE'
    ].includes(s)
  ) {
    baseColor = theme.palette.success.main
  } else if (
    [
      'INACTIVE',
      'PENDING',
      'CLOSED',
      'DRAFT',
      'PARTIAL',
      'WAITLIST',
      'LIABILITY',
      'UPDATE',
      'LOW_STOCK',
      'ARCHIVED',
      'TAXABLE',
      'INCLUSIVE',
      'SALE',
      'RETURN_CUSTOMER',
      'RETURN_SUPPLIER',
      'IMPORT_CONVERSION',
      'ADJUSTMENT_COUNT'
    ].includes(s)
  ) {
    baseColor = theme.palette.warning.main
  } else if (
    [
      'LOCKED',
      'FAILED',
      'OVERDUE',
      'CREDIT',
      'EXPIRED',
      'VOIDED',
      'REJECTED',
      'SUSPENDED',
      'CANCELLED',
      'EXPENSE',
      'DELETE',
      'EXCLUSIVE',
      'ADJUSTMENT_DAMAGE',
      'OUTFLOW'
    ].includes(s)
  ) {
    baseColor = theme.palette.error.main
  }

  return (
    <Chip
      label={s.replace('_', ' ')}
      icon={icon}
      size="small"
      sx={{
        backgroundColor: alpha(baseColor, 0.1),
        color: baseColor,
        border: `1px solid ${alpha(baseColor, 0.5)}`,
        fontWeight: 'bold',
        fontSize: '0.65rem',
        letterSpacing: '0.5px',
        height: 24,
        '& .MuiChip-icon': {
          color: baseColor,
          marginLeft: '6px',
          marginRight: '-4px'
        },
        ...sx
      }}
    />
  )
}

export default StatusChip
